module.exports = __webpack_public_path__ + "static/img/wl_ps.f455021c.png";